export default __webpack_public_path__ + "images/icons/chevron-down-1472650d831d73e00da9c08249695809.svg";